export const selectIsAlmaTunnusLoggedIn = state => state.almaUser.get('loggedIn')
export const selectIsAlmaTunnusEmailVerified = state => state.almaUser.get('emailVerified')
export const selectAlmaTunnusLogoutRequested = state => state.almaUser.get('logoutRequested')
export const selectAlmaTunnusLoginRequested = state => state.almaUser.get('loginRequested')
export const selectAlmaTunnusRegisterRequested = state => state.almaUser.get('registerRequested')

